import {debounce} from './helpers.js'

export default class FooterBottom {
    constructor() {
        if (this.footer = document.querySelector(".footer")) {
            this._getFooterHeight()

            window.addEventListener("resize", debounce(() =>
                this._getFooterHeight(), 250))
        }
    }

    _getFooterHeight() {
        this.footerHeight = this.footer.clientHeight
        document.body.style.paddingBottom = this.footerHeight + "px"
    }
}